module.exports = __webpack_public_path__ + "static/media/BABYGROK-BNB.1806359b.png";